import runAccessibility from "@/views/menu/runAccessibility";
import { renderWidget } from "@/views/widget/widget";
import { registerKeyboardShortcut } from "@/utils/keyboardShortcut";
import { pluginConfig } from "@/globals/pluginConfig";
import { openMenu } from "@/views/menu/menu";
import { userSettings, getSavedUserSettings } from "@/globals/userSettings";
import { changeLanguage } from "./i18n/changeLanguage";
import { getDefaultLanguage } from "./i18n/getDefaultLanguage";
import { loadLanguages } from "./i18n/Languages";

export interface AccessibilityWidget {
  changeLanguage: typeof changeLanguage;
}

/**
 * Shared runtime init (languages, saved settings, tool re-application).
 * Used by the plugin entry below and by the CDN core entry.
 */
export async function initRuntime(): Promise<void> {
  await loadLanguages();
  const savedSettings = getSavedUserSettings();
  Object.assign(userSettings, savedSettings);
  if (!userSettings.lang) {
    userSettings.lang = getDefaultLanguage();
  }
  runAccessibility();
}

export default async function accessibilityWidget(): Promise<AccessibilityWidget> {
  try {
    await initRuntime();
    renderWidget();
    registerKeyboardShortcut(pluginConfig.keyboard, openMenu);
    return { changeLanguage };
  } catch (error) {
    console.error("Failed to initialize accessibility widget:", error);
    return { changeLanguage };
  }
}